var _polygon, _polygon2, _rect, _circle, _circle2, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAadhaar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#90CAF9",
    points: "33,42 5,42 5,4 24,4 33,13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E1F5FE",
    points: "31.5,14 23,14 23,5.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.3,
    y: 34.8,
    transform: "matrix(.707 -.707 .707 .707 -17.177 40.055)",
    fill: "#616161",
    width: 2.8,
    height: 12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#616161",
    cx: 28,
    cy: 29,
    r: 11
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#90CAF9",
    cx: 28,
    cy: 29,
    r: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 37.6,
    transform: "matrix(.707 -.707 .707 .707 -17.661 41.223)",
    fill: "#37474F",
    width: 2.8,
    height: 8.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1976D2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,31h-9.7c0.4,1.6,1.3,3,2.5,4H30V31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,27H30v-4h-7.3C21.5,24,20.7,25.4,20.3,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,20H11v2h7.3C18.8,21.3,19.4,20.6,20.1,20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,24H11v2h5.4C16.6,25.3,16.8,24.6,17.1,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,29c0-0.3,0-0.7,0.1-1H11v2h5.1C16,29.7,16,29.3,16,29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4,32H11v2h6.1C16.8,33.4,16.6,32.7,16.4,32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAadhaar);
export default __webpack_public_path__ + "static/media/aadhaar.b21830447aac1a14bddddb6f00684e94.svg";
export { ForwardRef as ReactComponent };